import * as React from 'react';

interface Props {
  totalPages: number;
  allPages: number[];
  selectedPage: number;
  activeStyles: string;
  handlePageChange: (page: number) => void;
}

const PagesDisplay = ({ totalPages, allPages, selectedPage, activeStyles, handlePageChange }: Props) => {
  /**
   * renderPages
   * @function renderPages - Renders the list of available pages
   */
  const renderPages = () => {
    if (totalPages === 1) {
      return (
        <div className={activeStyles}>
          <span>{allPages[0]}</span>
        </div>
      );
    } else if (totalPages <= 4) {
      return allPages.map((page, index) => (
        <div key={index} className={selectedPage === page ? activeStyles : ''}>
          <span onClick={() => handlePageChange(page)}>{page}</span>
        </div>
      ));
    } else if (totalPages > 4 && selectedPage === 1) {
      return (
        <React.Fragment>
          <div className={activeStyles}>
            <span onClick={() => handlePageChange(selectedPage)}>{selectedPage}</span>
          </div>
          <div>
            <span onClick={() => handlePageChange(selectedPage + 1)}>{selectedPage + 1}</span>
          </div>
          <div>
            <span onClick={() => handlePageChange(selectedPage + 2)}>{selectedPage + 2}</span>
          </div>
          <div>
            <span onClick={() => handlePageChange(totalPages)}>...{totalPages}</span>
          </div>
        </React.Fragment>
      );
    } else if (totalPages > 4 && selectedPage === 2) {
      return (
        <React.Fragment>
          <div>
            <span onClick={() => handlePageChange(selectedPage - 1)}>{selectedPage - 1}</span>
          </div>
          <div className={activeStyles}>
            <span onClick={() => handlePageChange(selectedPage)}>{selectedPage}</span>
          </div>
          <div>
            <span onClick={() => handlePageChange(selectedPage + 1)}>{selectedPage + 1}</span>
          </div>
          <div>
            <span onClick={() => handlePageChange(totalPages)}>...{totalPages}</span>
          </div>
        </React.Fragment>
      );
    } else if (totalPages > 4 && (selectedPage === totalPages || selectedPage === totalPages - 1)) {
      return (
        <React.Fragment>
          <div>
            <span onClick={() => handlePageChange(1)}>1...</span>
          </div>
          <div className={selectedPage === totalPages - 2 ? activeStyles : ''}>
            <span onClick={() => handlePageChange(totalPages - 2)}>{totalPages - 2}</span>
          </div>
          <div className={selectedPage === totalPages - 1 ? activeStyles : ''}>
            <span onClick={() => handlePageChange(totalPages - 1)}>{totalPages - 1}</span>
          </div>
          <div className={selectedPage === totalPages ? activeStyles : ''}>
            <span onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
          </div>
        </React.Fragment>
      );
    } else if (totalPages > 4 && selectedPage <= totalPages - 2) {
      return (
        <React.Fragment>
          <div>
            <span onClick={() => handlePageChange(1)}>1...</span>
          </div>
          <div>
            <span onClick={() => handlePageChange(selectedPage - 1)}>{selectedPage - 1}</span>
          </div>
          <div className={activeStyles}>
            <span onClick={() => handlePageChange(selectedPage)}>{selectedPage}</span>
          </div>
          <div>
            <span onClick={() => handlePageChange(selectedPage + 1)}>{selectedPage + 1}</span>
          </div>
          <div>
            <span onClick={() => handlePageChange(totalPages)}>...{totalPages}</span>
          </div>
        </React.Fragment>
      );
    }

    return <div />;
  };

  return <React.Fragment>{renderPages()}</React.Fragment>;
};

export default PagesDisplay;
